"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runCompatibilityTest = runCompatibilityTest;
function runCompatibilityTest() {
  if (!this.config || !this.config.compatibilityTestCases || this.config.compatibilityTestCases.length <= 0) {
    return;
  }
  var videoEl = document.createElement('video');
  var compatibilityTestMap = {};
  this.config.compatibilityTestCases.forEach(function (testCase) {
    if (videoEl.canPlayType) {
      compatibilityTestMap[testCase.name] = videoEl.canPlayType(testCase.type);
    } else {
      compatibilityTestMap[testCase.name] = '';
    }
  });
  this.logger.logCompatibility(compatibilityTestMap);
}